import { gql } from 'graphql.macro';

export const GetIssueCompletionLookups = gql`

    query GetNearMissenumlookup($request: NearMissEnumLookupRequestInput) {
        closureReasons: nearmissenumlookup(request: $request) {
            id
            name: type
            description
        }
    }
`;
